import React, {useState} from 'react';
import { useStyles } from "./style";
import Alert from 'react-s-alert';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import UserInformation from './UserInformation'
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import {Container, Grid} from '@mui/material/';
//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import Formulario from 'components/formulario';

function FormularioCambiarContraseña(props) {
    const classes = useStyles();
    const [controller] = useState('user');
    const [open, setOpen] = React.useState(false),
          [mensaje, setMensaje] = React.useState({
              tipoError: '',
              tipoMensaje: ''
          })
    const [apiErrors] = React.useState([]);
    const [elements, setElements] = React.useState({
        password: { idelement: "password",  value:'', label: "Contraseña", pattern:"^[\\w_\\sÑñáéíóúÁÉÍÓÚ().!@#$%^&*/-]{6,20}$", validators: ['required'], errorMessages:['Alfanumérico y simbolos "().%$#/-@" de 6 a 20 caracteres'], isError:false, elementType:'password' },
        repassword: { idelement: "repassword",  value:'', label: "Repetir Contraseña", pattern:"^[\\w_\\sÑñáéíóúÁÉÍÓÚ().!@#$%^&*/-]{6,20}$", validators: ['required'], errorMessages:['Alfanumérico y simbolos "().%$#/-@" de 6 a 20 caracteres'], isError:false, elementType:'password' },
    });

    const handClose = (event, reason) => {
        if (reason === 'clickaway') {return;}
        setOpen(false);
    };

    const CambiarContraseña = async () =>{
        let updateElement  = {id: props.currentUser.id, password: elements.password.value, repassword: elements.repassword.value};
        if(elements.password.value === elements.repassword.value){
            try{
                const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(controller,'changePassword');    
                if (hasPermission.error){
                    setOpen (true)
                    setMensaje( {tipoError: 'warning', tipoMensaje: 'Lo siento, no tiene permisos'})
                }else{
                    const changePassword =  await ServiciosDelAPI.seguridadDeSSOUsuario.changePassword(updateElement);
                    if(changePassword.error!==null){
                        setOpen(true)
                        setMensaje({tipoError: 'error', tipoMensaje: 'Error al realizar la petición de cambio de contraseña'})
                    }else{
                        setOpen(true)
                        setMensaje({tipoError: 'success', tipoMensaje: '¡BIEN! Contraseña actualizada correctamente'})
                        elements.password.value="";
                        elements.repassword.value="";
                        setElements({ ...elements });                        
                    }   
                }
            }catch(exception){
                (exception.status===404) ? Alert.error("Falla del sistema"): Alert.error("Intente de nuevo ");
            }            
        }else{
            setOpen(true)
            setMensaje({tipoError: 'warning', tipoMensaje: '¡Contraseñas no coinciden!, intente de nuevo'})
        }        
    }

    const [buttonList]= React.useState({
        "register":{"label":"Cambiar Contraseña","callback":CambiarContraseña,"loading":false,"color":"#fff", "icon": "save", "width":230 ,"background":"#1C4E78"},
    });

    return (
        <div>
            <br/>
            <Container maxWidth="md">        
                <Grid container className={classes.colorComponente}>
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                        <UserInformation DatosUsuario={props.currentUser}/>
                        <AlertaDeRespuesta type={mensaje.tipoError} content={mensaje.tipoMensaje} open={open} handClose={handClose}/>
                    </Grid>
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center" className={classes.centrarBoton}>
                        <Formulario
                            elements= {elements} 
                            buttonList={buttonList}
                            apiErrors={apiErrors} 
                        />
                    </Grid>
                    <div className={classes.lineaDegradadaBottom}></div>
                </Grid>
            </Container>
        </div>
    );
}

export default connect(mapStateToProps)(FormularioCambiarContraseña);